import { ITiendaProductos } from "@/types/app";
import { separadorMiles } from "@/utils/global";
import { Eye } from "lucide-react";
import { LazyImage } from "@/Components/LazyImage";
import { memo } from "react";

const ProductGrid = memo(({ data }: { data: ITiendaProductos }) => {
    const precioConDescuento = (
        data.precio -
        data.precio * (data.descuento / 100)
    ).toFixed(0);

    const url =
        data.es_individual == 0
            ? `/producto/${encodeURIComponent(data.productoNombre)}`
            : `/producto/${encodeURIComponent(data.productoNombre)}/${encodeURIComponent(data.sabor)}`;

    return (
        <div className="product-item grid-type relative group transition-all duration-300 ease-in-out hover:shadow-md rounded-2xl">
            <a href={url} className="block">
                <div className="product-main cursor-pointer block">
                    <div className="product-thumb bg-white relative overflow-hidden rounded-2xl">
                        {data.descuento > 0 && (
                            <div className="product-tag text-button-uppercase text-white bg-red px-3 py-0.5 inline-block rounded-full absolute top-3 left-3 z-[1]">
                                Oferta
                            </div>
                        )}
                        <LazyImage
                            src={data.imagen}
                            width={500}
                            height={500}
                            alt={data.nombre}
                            className="group-hover:scale-105 transition-transform duration-300"
                            containerClassName="w-full aspect-[3/4] fotos rounded-2xl"
                        />

                        {/* Botón Ver Detalles - sin blur */}
                        <div className="absolute bottom-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                            <div className="bg-white px-3 py-1.5 rounded-full shadow-md border border-gray-100 flex items-center gap-1 hover:shadow-lg transition-all duration-300 active:scale-[0.98]">
                                <Eye className="w-3 h-3 text-[#790546]" />
                                <span className="text-[#790546] font-medium text-xs">
                                    Ver Detalles
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="product-infor mt-4 lg:mb-7 flex flex-col items-center text-center">
                        <div className="product-name text-title text-[#790546] font-bold group-hover:text-[#6a0440] transition-colors duration-300">
                            {data.nombre}
                        </div>

                        <div className="product-price-block flex items-center justify-center gap-2 flex-wrap mt-1 duration-300 relative z-[1]">
                            <div className="product-price text-title group-hover:text-[#6a0440] transition-colors duration-300">
                                ${separadorMiles(precioConDescuento)}
                            </div>
                            {data.descuento > 0 && (
                                <>
                                    <div
                                        className="product-origin-price caption1 text-gray-400 line-through"
                                    >
                                        {separadorMiles(data.precio)}
                                    </div>
                                    <div className="product-sale caption1 font-medium bg-green px-3 py-0.5 inline-block rounded-full">
                                        -{data.descuento}%
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
});

ProductGrid.displayName = 'ProductGrid';

export default ProductGrid;
